import {SET_USER_TOKEN,
        SET_USER_LOGGED_IN,
        SET_USER_PUBLIC,
        SET_USER_NO_COMPANY,
        SET_USER_PROFILE,
        SET_USER_RANK,
        SET_USER_HEALTH,
        SET_USER_BADGE_NUMBERS,
        SET_USER_ANNOUNCEMENTS_BADGE_DATE} from 'actions/types';



const initialState = {loggedIn:false, token:'', userProfile:null, badgeNumbers:{}, noCompany:false};
export default (state = initialState, action) => {
    switch(action.type) {
        case SET_USER_LOGGED_IN: 
            return {...state, loggedIn:action.loggedIn};
        case SET_USER_TOKEN: // deprecated
            return {...state, token:action.token};
        case SET_USER_PUBLIC: 
            return {...state, isPublicComputer:action.isPublicComputer};
        case SET_USER_NO_COMPANY:
            return {...state, noCompany:action.noCompany};
        case SET_USER_PROFILE: 
            return {...state, userProfile:action.userProfile};
        case SET_USER_RANK: 
            return {...state, rank:action.rank};
        case SET_USER_HEALTH: 
            return {...state, health:action.health};
        case SET_USER_BADGE_NUMBERS: 
            return {...state, badgeNumbers:action.badgeNumbers};
        case SET_USER_ANNOUNCEMENTS_BADGE_DATE: 
            return {...state, userProfile:{...state.userProfile, companyAnnouncementsBadgeDate:action.companyAnnouncementsBadgeDate}};
        default: 
            return state;
    }
}

export const getIsLoggedIn = state => state.loggedIn;
export const getUserProfileWithDefaults = state => {
    var userProfile = {firstName:'', lastName:'', birthDate:'', team:null, company:null};

    if(state.userProfile) {
        userProfile = {...userProfile, ...state.userProfile}; 
    }
    if(userProfile.team===null) {
        userProfile.team = {name:''};
    }
    if(userProfile.company===null) {
        userProfile.company = {name:''};
    }

    return userProfile;
}
export const getUserProfileCompanyAnnouncementsBadgeDate = state => {
    var result = null;
    if(state.userProfile) {
        result = state.userProfile.companyAnnouncementsBadgeDate;
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/reducers/user.js